<footer class="bg-white pb-10 pt-24">
  <div class="mx-auto max-w-page px-4 sm:px-6 lg:px-8">
    <div class="grid gap-14 border-b border-slate-200 pb-14 lg:grid-cols-[1.2fr_0.8fr]">
      <div class="flex max-w-md flex-col gap-8">
        <div class="flex items-center gap-3">
          <img
            src="assets/brand/logo.svg"
            width="44"
            height="44"
            alt="FormOps logo"
            class="h-11 w-11 shrink-0" />

          <div>
            <p class="text-h6 text-slate-950">FormOps</p>
            <p class="text-caption text-slate-500">AI-powered form operations</p>
          </div>
        </div>

        <p class="text-body1 leading-8 text-slate-600">
          Create forms, collect submissions, and uncover AI-powered insights
          from your operational data.
        </p>

        <div class="flex items-center gap-3">
          <a
            href="#"
            class="flex h-11 w-11 cursor-pointer items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-950">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22 5.8a8.5 8.5 0 01-2.36.64A4.13 4.13 0 0021.45 4a8.28 8.28 0 01-2.61 1A4.11 4.11 0 0015.85 4c-2.63 0-4.55 2.45-3.96 5A11.65 11.65 0 013 4.79a4.11 4.11 0 001.27 5.49A4.07 4.07 0 012.8 9.7v.05a4.11 4.11 0 003.3 4 4.1 4.1 0 01-1.85.07 4.11 4.11 0 003.84 2.85A8.25 8.25 0 012 18.58 11.63 11.63 0 008.29 20c7.55 0 11.8-6.38 11.54-12.1A8.18 8.18 0 0022 5.8z" />
            </svg>
          </a>

          <a
            href="#"
            class="flex h-11 w-11 cursor-pointer items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-950">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 0H5C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zM7.1 20H3.56V9h3.54v11zM5.33 7.54A2.05 2.05 0 117.38 5.5a2.05 2.05 0 01-2.05 2.04zM20.44 20H16.9v-5.36c0-1.28-.03-2.93-1.78-2.93-1.78 0-2.06 1.39-2.06 2.83V20H9.52V9h3.4v1.5h.05c.47-.9 1.63-1.84 3.36-1.84 3.59 0 4.25 2.36 4.25 5.43V20z" />
            </svg>
          </a>

          <a
            href="#"
            class="flex h-11 w-11 cursor-pointer items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-950">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 .5C5.65.5.5 5.65.5 12A11.5 11.5 0 008.36 22.95c.61.11.83-.27.83-.58v-2.03c-3.4.74-4.12-1.45-4.12-1.45-.55-1.4-1.35-1.77-1.35-1.77-1.11-.75.08-.73.08-.73 1.22.09 1.86 1.26 1.86 1.26 1.09 1.86 2.85 1.32 3.55 1 .11-.79.42-1.32.76-1.62-2.71-.31-5.57-1.36-5.57-6.07 0-1.34.48-2.44 1.26-3.3-.13-.31-.55-1.56.12-3.25 0 0 1.03-.33 3.38 1.26a11.6 11.6 0 016.16 0c2.35-1.59 3.38-1.26 3.38-1.26.67 1.69.25 2.94.12 3.25.78.86 1.26 1.96 1.26 3.3 0 4.72-2.87 5.75-5.6 6.05.44.38.83 1.13.83 2.29v3.4c0 .32.22.7.84.58A11.5 11.5 0 0023.5 12C23.5 5.65 18.35.5 12 .5z" />
            </svg>
          </a>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:grid-cols-4">
        <div class="flex flex-col gap-5">
          <p class="text-body2 font-semibold text-slate-950">Product</p>

          <div class="flex flex-col gap-4">
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Forms</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Submissions</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">AI Insights</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Integrations</a>
          </div>
        </div>

        <div class="flex flex-col gap-5">
          <p class="text-body2 font-semibold text-slate-950">Resources</p>

          <div class="flex flex-col gap-4">
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Documentation</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Guides</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">API</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Support</a>
          </div>
        </div>

        <div class="flex flex-col gap-5">
          <p class="text-body2 font-semibold text-slate-950">Company</p>

          <div class="flex flex-col gap-4">
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">About</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Privacy</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Terms</a>
            <a href="#" class="block cursor-pointer text-body2 text-slate-600 transition hover:text-slate-950">Contact</a>
          </div>
        </div>

        <div class="flex flex-col gap-5">
          <p class="text-body2 font-semibold text-slate-950">Theme</p>

          <div class="flex flex-col gap-4">
            @for (mode of themeModes; track mode.value) {
              <button
                type="button"
                (click)="setTheme(mode.value)"
                class="flex cursor-pointer items-center gap-3 text-body2 transition hover:text-slate-950"
                [class.font-semibold]="themeService.themeMode() === mode.value"
                [class.text-slate-950]="themeService.themeMode() === mode.value"
                [class.text-slate-600]="themeService.themeMode() !== mode.value">
                <app-svg-icon [src]="mode.icon" [size]="20" />
                {{ mode.label }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4 pt-8 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
      <p class="text-body2 text-slate-500">© 2026 FormOps. All rights reserved.</p>
      <p class="text-body2 text-slate-500">Built for modern operational teams.</p>
    </div>
  </div>
</footer>

